import React from 'react';
import { observer } from 'mobx-react';
import ReportsMenuComponent from './Reports-menu.component';
import useReportsMenu from './useReportsMenu';

const Container: React.FC = () => {
    const { lang, user, groups, handlers, state, reports, devices } =
        useReportsMenu();

    return (
        <>
            <ReportsMenuComponent
                report={reports.report}
                reports={reports.reports}
                lang={lang.lang}
                devices={devices.deviceList}
                selectedDevice={state.selectedDevice}
                fromDateFilterCurrent={state.fromDateFilterCurrent}
                toDateFilterCurrent={state.toDateFilterCurrent}
                dateFilter={state.dateFilter}
                groups={groups.groupsList}
                selectedGroup={state.selectedGroup}
                timezone={user.settings.timezone ?? 0}
                onReportChange={handlers.handleReportChange}
                onReportClick={handlers.handleReportClick}
                onDeviceChange={handlers.handleDeviceChange}
                onFromDateChange={handlers.handleFromDateChange}
                onToDateChange={handlers.handleToDateChange}
                onDateFilterChange={handlers.handleDateFilterChange}
                onGroupChange={handlers.handleGroupChange}
            />
        </>
    );
};

const ReportsMenuContainer = observer(Container);

export default ReportsMenuContainer;
